import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10 5a8.142 8.142 0 0 1 7.35 4.583 8.038 8.038 0 0 1-2.008 2.6l1.175 1.175a9.835 9.835 0 0 0 2.65-3.775c-1.442-3.658-5-6.25-9.167-6.25a9.875 9.875 0 0 0-3.033.475l1.375 1.375A8.424 8.424 0 0 1 10 5Zm-.892.95 1.725 1.725c.475.208.859.592 1.067 1.067l1.725 1.725c.067-.284.117-.584.117-.892.008-2.067-1.675-3.742-3.742-3.742-.308 0-.6.042-.892.117ZM1.675 3.225l2.233 2.233A9.781 9.781 0 0 0 .833 9.583c1.442 3.659 5 6.25 9.167 6.25a9.776 9.776 0 0 0 3.6-.683L16.45 18l1.175-1.175L2.85 2.042 1.675 3.225Zm6.25 6.25L10.1 11.65c-.033.008-.067.017-.1.017a2.084 2.084 0 0 1-2.083-2.084c0-.041.008-.066.008-.108ZM5.092 6.642 6.55 8.1c-.192.458-.3.958-.3 1.483a3.756 3.756 0 0 0 5.225 3.45l.817.817c-.734.2-1.5.317-2.292.317a8.142 8.142 0 0 1-7.35-4.584 8.252 8.252 0 0 1 2.442-2.941Z",
    fill: "#757575"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h20v20H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };